import type { AskPosition, AskResponse, LegislatorVote, SentimentDisposition, VoteAlignment } from '../../../types/lobbyDay'

export function deriveAlignment(vote: LegislatorVote, position: AskPosition): VoteAlignment {
  if (vote === 'DidNotVote') return 'NoVote'
  if (vote === 'Yea') return position === 'Support' ? 'AlignedWithUs' : position === 'Oppose' ? 'AgainstUs' : 'Ambiguous'
  if (vote === 'Nay') return position === 'Support' ? 'AgainstUs' : position === 'Oppose' ? 'AlignedWithUs' : 'Ambiguous'
  return 'Ambiguous' // NotRecorded
}

export function classifyDisposition(promise: AskResponse, alignment: VoteAlignment): SentimentDisposition {
  switch (alignment) {
    case 'AlignedWithUs': return 'Excited'
    case 'AgainstUs': return promise === 'Yes' ? 'Betrayed' : 'Jilted'
    case 'NoVote': return promise === 'Yes' ? 'Betrayed' : 'Jilted'
    default: return 'Pending' // Ambiguous
  }
}

export function resolveDisposition(
  computed: SentimentDisposition,
  overrideValue: SentimentDisposition | null | undefined,
): SentimentDisposition {
  return overrideValue ?? computed
}

export function dispositionFor(
  promise: AskResponse, vote: LegislatorVote,
  overrideValue: SentimentDisposition | null | undefined, position: AskPosition,
): SentimentDisposition {
  return overrideValue ?? classifyDisposition(promise, deriveAlignment(vote, position))
}
